import { NEWS_PUBLISHERS, type NewsPublisherId } from '../constants/newsPublishers';
import { parseNewsRssXml } from '../utils/parseNewsRss';
import type { NewsStory } from '../utils/newsStory';

export type PublisherFeedResult = {
  publisherId: NewsPublisherId;
  label: string;
  stories: NewsStory[];
  error?: string;
};

export async function fetchPublisherFeed(
  publisherId: NewsPublisherId,
  limit: number,
  signal?: AbortSignal
): Promise<PublisherFeedResult> {
  const pub = NEWS_PUBLISHERS[publisherId];
  const init: RequestInit = {
    headers: {
      Accept: 'application/rss+xml,application/xml,application/atom+xml;q=0.9,*/*;q=0.8',
    },
  };
  if (signal) init.signal = signal;

  try {
    const res = await fetch(pub.proxyPath, init);
    if (!res.ok) throw new Error(`${pub.label} returned ${res.status}`);
    const xml = await res.text();
    const stories = parseNewsRssXml(xml, publisherId, pub.label).slice(0, limit);
    return { publisherId, label: pub.label, stories };
  } catch (err) {
    return {
      publisherId,
      label: pub.label,
      stories: [],
      error: (err as Error).message,
    };
  }
}
